import { useLayoutEffect, useState } from "react";

type StorageType = "local" | "session";

export function useStateWithLocalStorage<T>(
  key: string,
  defaultValue: T,
  storageType: StorageType = "local"
): [T, (value: T) => void] {
  const storage = getStorage(storageType);
  const initialValueStr = storage.getItem(key);
  let initialValue: T;
  try {
    initialValue = initialValueStr ? (JSON.parse(initialValueStr) as T) : defaultValue;
  } catch (e) {
    initialValue = defaultValue;
  }
  const [value, setValueOriginal] = useState<T>(initialValue);

  const setValue = (value: T) => {
    setValueOriginal(value);
    storage.setItem(key, JSON.stringify(value));
  };

  useLayoutEffect(() => {
    storage.setItem(key, JSON.stringify(initialValue));
  }, [initialValue, key, storage]);

  return [value, setValue];
}

const getStorage = (storageType: StorageType) => {
  return storageType === "local" ? window.localStorage : window.sessionStorage;
};
